<app-presentation></app-presentation>
<app-descrizione-prodotto></app-descrizione-prodotto>
<app-descrizione-gps></app-descrizione-gps>
<app-sezione-arte></app-sezione-arte>
<app-caratteristiche-prodotto></app-caratteristiche-prodotto>
<app-prezzi></app-prezzi>
<app-chi-siamo></app-chi-siamo>
